module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"refused":"Rechazado por elegibilidad"}}')
  delete Component.options._Ctor
}
